
import Alert from 'vux/src/components/alert/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Group from 'vux/src/components/group/index.vue'


export default {
name: 'vip',
components: {
Card,
Divider,
Cell,
Group,
Badge,
CellBox,
Confirm,
Alert
},
data() {
return {

setimgUrl: '/static/img/set.png',
imgUrl: '/static/img/vip.png',
account: '',
name: '',
mobile: '',
showContent001: false,
isIndv: false,
isExpt: false,
isEntp: false,
isSrvp: false,
isAdmin: false,
isSrvpAdmin: false,
isLog: false,
adSrc: '/static/img/ad.png',
list: []
}
},
methods: {
add() {
if (!this.isIndv && this.isExpt) {
this.$router.push({name: 'addmyInfo'})
}
if (this.isIndv && !this.isExpt) {
this.$router.push({name: 'addexpertInfo'})
}
},
myidentity() {
this.showContent001 = !this.showContent001;
},
logout() {
var obj = {
name: this.name,
mobile: this.mobile
}
this.$router.push({name: 'glzh', params: {obj: obj}})
}
},
created() {
const openid = localStorage.getItem('openid');
const unionid = localStorage.getItem('unionid')
let account = JSON.parse(localStorage.getItem('account'));







console.log(account)
let account1 = '';
if (account.length > 0){
account.forEach(item => {
if (item.role === 'EXPT') {
this.isExpt = true;
account1 = item.account
} else if (item.role === 'INDV') {
this.isIndv = true;
account1 = item.account
} else if (item.role === 'SRVP') {
this.isSrvpAdmin = true;
this.$http.post('api/v1/wechat/' + localStorage.getItem('unionid') + '/token', {'account': item.account}).then(response => {
this.$http.get('api/v1/accounts/' + response.data.userid, {
headers: {
token: response.data.token,
opid: response.data.userid
}
}).then(res => {
res.data.forEach(item => {
this.isLog = item.supported.indexOf('log') !== -1
})
})
})
} else if (item.role === 'ADMIN') {
this.isAdmin = true;
}
})

if(account1 != ''){
this.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account1})
.then(res => {
localStorage.setItem('token', res.data.token);
localStorage.setItem('userid', res.data.userid);
let url;
if (account[0].role === 'EXPT') {
url = '/api/v1/experts/'
} else {
url = '/api/v1/users/'
}
this.$http.get(url + res.data.userid, {
headers: {
token: res.data.token,
opid: res.data.userid
}
}).then((response) => {
if (response.data.detail) {
this.name = response.data.detail.name
this.mobile = response.data.account
}
})
})
.catch(error => {
this.$vux.toast.show({
text: JSON.parse(error.response.data.error_message).faultstring,
type: 'cancel',
time: '1000'
})
});
}else{
this.$router.push({path: '/login'})
}


}else{
this.$router.push({path: '/login'})
}
},
}



// WEBPACK FOOTER //
// ./src/components/vip.vue